// extracted by mini-css-extract-plugin
export var centerList = "_gl-6";
export var centerLoc = "_gl-a";
export var centerName = "_gl-9";
export var centerOptionBody = "_gl-8";
export var centerRow = "_gl-7";
export var centerStatus = "_gl-b";
export var empty = "_gl-5";
export var externalIcon = "_gl-c";
export var fieldHeader = "_gl-2";
export var fieldHelp = "_gl-4";
export var fieldLabel = "_gl-3";
export var panel = "_gl-0";
export var removeBtn = "_gl-d";
export var section = "_gl-1";